import API from './api/common.js'

export default {
  data() {
    return {
      cuonaApiVersion: null
    }
  },
  methods: {
    retrieveCuonaApiVersion() {
      const that = this;
      API.getVersion().then(function(response) {
        that.cuonaApiVersion = response.version;
      });
    }
  },
  mounted() {
    this.retrieveCuonaApiVersion();
  }
}
